import { VerifierDetailsData } from "../../../route/public/verifier/details/page/useDetails";
import { PublicVerifierDetailsMetaTags, VerifierDetails } from "../components";
import { usePublicVerifierDetailsPageTemplate } from "./usePublicVerifierDetailsPageTemplate";

interface PublicVerifierDetailsPageTemplateProps {
  verifierDetailsData: VerifierDetailsData;
}

export const PublicVerifierDetailsPageTemplate = ({
  verifierDetailsData,
}: PublicVerifierDetailsPageTemplateProps): JSX.Element => {
  const { verifierUuid, navigateBackToProject, showContactUsModal, setShowContactUsModal } =
    usePublicVerifierDetailsPageTemplate();
  return (
    <div>
      <PublicVerifierDetailsMetaTags verifierDetailsData={verifierDetailsData} />
      <VerifierDetails
        data={verifierDetailsData}
        verifierUuid={verifierUuid}
        isPreview={false}
        navigateBackToProject={navigateBackToProject}
        showContactUsModal={showContactUsModal}
        setShowContactUsModal={setShowContactUsModal}
      />
    </div>
  );
};
